import { PaycheckRoutingConfigStatus } from './entityTypes';

export const JOINED_DATA_SEPARATOR = ', ';

export const PAYCHECK_STATUS_ORDER = [
    PaycheckRoutingConfigStatus.ACTIVE,
    PaycheckRoutingConfigStatus.INACTIVE,
    'ELIGIBLE',
];
